var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SkillStatus } from '../../../../constants/statuses';
import { VISIBLE_COLUMNS_COUNT } from '../../../../constants/table';
var findActualGradePageIndex = function (gradesPerPage, actualGradeValue) {
    var pageIdx = gradesPerPage.findIndex(function (grades) { var _a; return ((_a = grades[0]) === null || _a === void 0 ? void 0 : _a.value) === actualGradeValue; });
    if (pageIdx === -1) {
        pageIdx = gradesPerPage.findIndex(function (grades) {
            return grades.some(function (el) { return el.value === actualGradeValue; });
        });
    }
    return pageIdx;
};
var findSelectedGradePageIndex = function (gradesPerPage, selectedGradeShortName) {
    var pageIdx = gradesPerPage.findIndex(function (grades) { var _a; return ((_a = grades[0]) === null || _a === void 0 ? void 0 : _a.shortName) === selectedGradeShortName; });
    if (pageIdx === -1) {
        pageIdx = gradesPerPage.findIndex(function (grades) {
            return grades.some(function (el) { return el.shortName === selectedGradeShortName; });
        });
    }
    return pageIdx;
};
var calculateGradesPerPage = function (grades) {
    var gradesPerPage = [];
    var renderedGrades = [];
    var columnsCounter = 0;
    var rangeGrade = function (grade) {
        columnsCounter += grade.skills.length;
        if (columnsCounter <= VISIBLE_COLUMNS_COUNT) {
            renderedGrades.push(grade);
            return;
        }
        var diff = columnsCounter - VISIBLE_COLUMNS_COUNT;
        var skillsToShow = grade.skills.length - diff;
        var partialGrade = __assign(__assign({}, grade), { skills: grade.skills.slice(0, skillsToShow) });
        gradesPerPage.push(__spreadArray(__spreadArray([], renderedGrades, true), [partialGrade], false));
        renderedGrades.length = 0;
        columnsCounter = grade.skills.length;
        if (columnsCounter <= VISIBLE_COLUMNS_COUNT) {
            renderedGrades.push(grade);
            return;
        }
        var gradePage = 0;
        while (columnsCounter > VISIBLE_COLUMNS_COUNT) {
            gradePage += 1;
            var startIdx = (gradePage - 1) * VISIBLE_COLUMNS_COUNT;
            var lastIdx = startIdx + VISIBLE_COLUMNS_COUNT;
            gradesPerPage.push([
                __assign(__assign({}, grade), { skills: grade.skills.slice(startIdx, lastIdx) }),
            ]);
            columnsCounter -= VISIBLE_COLUMNS_COUNT;
        }
        if (columnsCounter > 0) {
            var partialGrade_1 = __assign(__assign({}, grade), { skills: grade.skills.slice(gradePage * VISIBLE_COLUMNS_COUNT) });
            renderedGrades.push(partialGrade_1);
            columnsCounter = partialGrade_1.skills.length;
        }
    };
    grades.forEach(rangeGrade);
    if (renderedGrades.length > 0)
        gradesPerPage.push(renderedGrades);
    return gradesPerPage;
};
var getActualGrade = function (grades, students, filters) {
    var gradesFilledSkillsAmounts = [];
    var gradesProgressAmounts = [];
    var gradesHelpHeededAmounts = [];
    grades.forEach(function (grade) {
        var skillsInProgressCount = 0;
        var skillsFilledCount = 0;
        var skillsHelpNeededCount = 0;
        grade.skills.forEach(function (skill) {
            students.forEach(function (student) {
                student.skills.forEach(function (studentSkill) {
                    if (studentSkill.skillId === skill.id) {
                        skillsFilledCount += 1;
                        if (studentSkill.inProgress)
                            skillsInProgressCount += 1;
                        if (studentSkill.status === SkillStatus.HelpNeeded)
                            skillsHelpNeededCount += 1;
                    }
                });
            });
        });
        gradesFilledSkillsAmounts.push(skillsFilledCount);
        gradesProgressAmounts.push(skillsInProgressCount);
        gradesHelpHeededAmounts.push(skillsHelpNeededCount);
    });
    if ((filters === null || filters === void 0 ? void 0 : filters[0]) === 'true') {
        var maxHelpHeeded_1 = Math.max.apply(Math, gradesHelpHeededAmounts);
        if (maxHelpHeeded_1 > 0) {
            return grades[gradesHelpHeededAmounts.findIndex(function (num) { return num === maxHelpHeeded_1; })];
        }
    }
    var maxInProgress = Math.max.apply(Math, gradesProgressAmounts);
    if (maxInProgress > 0) {
        return grades[gradesProgressAmounts.findIndex(function (num) { return num === maxInProgress; })];
    }
    var maxFilled = Math.max.apply(Math, gradesFilledSkillsAmounts);
    if (maxFilled > 0) {
        return grades[gradesFilledSkillsAmounts.findIndex(function (num) { return num === maxFilled; })];
    }
    return null;
};
export { findActualGradePageIndex, findSelectedGradePageIndex, getActualGrade, calculateGradesPerPage, };
